export class EnumUtils {

  private static getEnumKeyValue<T extends {[key: string]: any}>(myEnum: T, inputEnumValue: any, ignoreCase?: boolean): [keyof T, T[keyof T]] | null {
    const shouldIgnoreCase = typeof inputEnumValue === 'string' && ignoreCase !== false;
    const inputEnumValueTransformed = shouldIgnoreCase ? inputEnumValue.toLowerCase() : inputEnumValue;
    return Object.entries(myEnum).find(([_, val]) => {
      return (typeof val === 'string' && shouldIgnoreCase)
        ? val.toLowerCase() === inputEnumValueTransformed
        : val === inputEnumValue;
    });
  }

  public static parseEnum<T extends {[key: string]: any}>(myEnum: T, inputEnumValue: any, ignoreCase?: boolean): T[keyof T] | null {
    return this.getEnumKeyValue(myEnum, inputEnumValue, ignoreCase)?.[1] ?? null;
  }

  public static getEnumKeyByValue<T extends {[key: string]: any}>(myEnum: T, inputEnumValue: any, ignoreCase?: boolean): keyof T | null {
    return this.getEnumKeyValue(myEnum, inputEnumValue, ignoreCase)?.[0] ?? null;
  }

  public static getEnumKeyIndexByValue<T extends {[key: string]: any}>(myEnum: T, enumValue: T[keyof T]): number {
    return Object.keys(myEnum).findIndex(x => myEnum[x] === enumValue);
  }

  public static lessThan<T extends {[key: string]: any}>(myEnum: T, key: T[keyof T], other: T[keyof T]): boolean {
    const [i1, i2] = this.getIndexes(myEnum, key, other);
    return i1 < i2;
  }

  public static lessThanOrEqual<T extends {[key: string]: any}>(myEnum: T, key: T[keyof T], other: T[keyof T]): boolean {
    const [i1, i2] = this.getIndexes(myEnum, key, other);
    return i1 <= i2;
  }

  public static greaterThan<T extends {[key: string]: any}>(myEnum: T, key: T[keyof T], other: T[keyof T]): boolean {
    const [i1, i2] = this.getIndexes(myEnum, key, other);
    return i1 > i2;
  }

  public static greaterThanOrEqual<T extends {[key: string]: any}>(myEnum: T, key: T[keyof T], other: T[keyof T]): boolean {
    const [i1, i2] = this.getIndexes(myEnum, key, other);
    return i1 >= i2;
  }

  public static enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
  }

  private static getIndexes<T extends {[key: string]: any}>(myEnum: T, key: T[keyof T], other: T[keyof T]): [number, number] {
    const i1 = EnumUtils.getEnumKeyIndexByValue(myEnum, key);
    if (i1 < 0) throw new Error('Invalid value ' + key);
    const i2 = EnumUtils.getEnumKeyIndexByValue(myEnum, other);
    if (i2 < 0) throw new Error('Invalid value ' + other);
    return [i1, i2];
  }
}
